module.exports = __webpack_public_path__ + "static/media/insider-perspective.cc4ca2ff.svg";